import { Reducer } from 'redux';

import { ToastAction } from '../../domains/toast/actions.types';

import { Toast } from './types';

export type { ToastAction };

const initialState: Toast = {
  id: 0,
  isErrorToast: false,
};

const reducer: Reducer<Toast, ToastAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOAST.SHOW':
      return {
        id: state.id + 1,
        text: action.payload.text,
        isErrorToast: action.payload.isErrorToast,
      };
    case 'TOAST.HIDE':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
